import {
  Airplay,
  Apple,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Asana,
  Atom,
  BadgeCheck,
  Bell,
  Book,
  BookStack,
  Box,
  BrainResearch,
  Calendar,
  Camera,
  ChatBubble,
  ChatBubbleQuestion,
  Check,
  CheckCircle,
  Circle,
  CircleSpark,
  Clock,
  Cloud,
  Code,
  CodeBrackets,
  Collapse,
  Component,
  Computer,
  Copy,
  Cpu,
  CreditCard,
  Cube,
  Database,
  DatabaseSettings,
  DesignPencil,
  Download,
  EditPencil,
  Eye,
  EyeClosed,
  FastArrowDown,
  FastArrowUp,
  Filter,
  Flask,
  Folder,
  Gift,
  GitBranch,
  GitCommit,
  GitFork,
  GitMerge,
  Globe,
  GraduationCap,
  GraphUp,
  Group,
  Headset,
  Heart,
  HelpCircle,
  Home,
  InfoCircle,
  Key,
  Lamp,
  Link,
  List,
  Lock,
  LogIn,
  LogOut,
  Mail,
  Map as MapIcon,
  Menu,
  Message,
  MessageText,
  Minus,
  MoreVert,
  NavArrowDown,
  NavArrowLeft,
  NavArrowRight,
  NavArrowUp,
  Network,
  Package,
  Page,
  PageEdit,
  Palette,
  Plus,
  PlusCircle,
  Position,
  Refresh,
  RefreshDouble,
  Rocket,
  Search,
  SelectPoint3d,
  Send,
  Server,
  Settings,
  ShareIos,
  Shield,
  Sparks,
  SquareDashed,
  Star,
  StatsUpSquare,
  Terminal,
  TestTube,
  Trash,
  Undo,
  Upload,
  User,
  ViewGrid,
  WarningCircle,
  WarningSquare,
  WarningTriangle,
  Xmark
} from 'iconoir-react';

import {
  FONT_AWESOME_TO_ICONOIR,
  normalizeIconName
} from './fontAwesomeToIconoir';

import type { IconoirIcon } from '~/common/types/Icon';

export type IconOption = {
  name: string;
  icon: IconoirIcon;
  category?: string;
};

export const ICONOIR_ICONS: IconOption[] = [
  { name: 'Airplay', icon: Airplay, category: 'Technology' },
  { name: 'Apple', icon: Apple, category: 'Brands' },
  { name: 'Archive', icon: Archive, category: 'Files' },
  { name: 'ArrowDown', icon: ArrowDown, category: 'Arrows' },
  { name: 'ArrowLeft', icon: ArrowLeft, category: 'Arrows' },
  { name: 'ArrowRight', icon: ArrowRight, category: 'Arrows' },
  { name: 'ArrowUp', icon: ArrowUp, category: 'Arrows' },
  { name: 'Asana', icon: Asana, category: 'Brands' },
  { name: 'Atom', icon: Atom, category: 'Technology' },
  { name: 'BadgeCheck', icon: BadgeCheck, category: 'Interface' },
  { name: 'Bell', icon: Bell, category: 'Communication' },
  { name: 'Book', icon: Book, category: 'Education' },
  { name: 'BookStack', icon: BookStack, category: 'Education' },
  { name: 'Box', icon: Box, category: 'Objects' },
  { name: 'BrainResearch', icon: BrainResearch, category: 'Technology' },
  { name: 'Calendar', icon: Calendar, category: 'Time' },
  { name: 'Camera', icon: Camera, category: 'Media' },
  { name: 'ChatBubble', icon: ChatBubble, category: 'Communication' },
  {
    name: 'ChatBubbleQuestion',
    icon: ChatBubbleQuestion,
    category: 'Communication'
  },
  { name: 'Check', icon: Check, category: 'Actions' },
  { name: 'CheckCircle', icon: CheckCircle, category: 'Actions' },
  { name: 'Circle', icon: Circle, category: 'Shapes' },
  { name: 'CircleSpark', icon: CircleSpark, category: 'Interface' },
  { name: 'Clock', icon: Clock, category: 'Time' },
  { name: 'Cloud', icon: Cloud, category: 'Technology' },
  { name: 'Code', icon: Code, category: 'Development' },
  { name: 'CodeBrackets', icon: CodeBrackets, category: 'Development' },
  { name: 'Collapse', icon: Collapse, category: 'Actions' },
  { name: 'Component', icon: Component, category: 'Development' },
  { name: 'Computer', icon: Computer, category: 'Technology' },
  { name: 'Copy', icon: Copy, category: 'Actions' },
  { name: 'Cpu', icon: Cpu, category: 'Technology' },
  { name: 'CreditCard', icon: CreditCard, category: 'Finance' },
  { name: 'Cube', icon: Cube, category: 'Shapes' },
  { name: 'Database', icon: Database, category: 'Data' },
  { name: 'DatabaseSettings', icon: DatabaseSettings, category: 'Data' },
  { name: 'DesignPencil', icon: DesignPencil, category: 'Design' },
  { name: 'Download', icon: Download, category: 'Actions' },
  { name: 'EditPencil', icon: EditPencil, category: 'Actions' },
  { name: 'Eye', icon: Eye, category: 'Interface' },
  { name: 'EyeClosed', icon: EyeClosed, category: 'Interface' },
  { name: 'FastArrowDown', icon: FastArrowDown, category: 'Arrows' },
  { name: 'FastArrowUp', icon: FastArrowUp, category: 'Arrows' },
  { name: 'Filter', icon: Filter, category: 'Interface' },
  { name: 'Flask', icon: Flask, category: 'Science' },
  { name: 'Folder', icon: Folder, category: 'Files' },
  { name: 'Gift', icon: Gift, category: 'Objects' },
  { name: 'GitBranch', icon: GitBranch, category: 'Development' },
  { name: 'GitCommit', icon: GitCommit, category: 'Development' },
  { name: 'GitFork', icon: GitFork, category: 'Development' },
  { name: 'GitMerge', icon: GitMerge, category: 'Development' },
  { name: 'Globe', icon: Globe, category: 'Interface' },
  { name: 'GraduationCap', icon: GraduationCap, category: 'Education' },
  { name: 'GraphUp', icon: GraphUp, category: 'Data' },
  { name: 'Group', icon: Group, category: 'Users' },
  { name: 'Headset', icon: Headset, category: 'Communication' },
  { name: 'Heart', icon: Heart, category: 'Social' },
  { name: 'HelpCircle', icon: HelpCircle, category: 'Interface' },
  { name: 'Home', icon: Home, category: 'Interface' },
  { name: 'InfoCircle', icon: InfoCircle, category: 'Interface' },
  { name: 'Key', icon: Key, category: 'Security' },
  { name: 'Lamp', icon: Lamp, category: 'Objects' },
  { name: 'Link', icon: Link, category: 'Actions' },
  { name: 'List', icon: List, category: 'Interface' },
  { name: 'Lock', icon: Lock, category: 'Security' },
  { name: 'LogIn', icon: LogIn, category: 'Actions' },
  { name: 'LogOut', icon: LogOut, category: 'Actions' },
  { name: 'Mail', icon: Mail, category: 'Communication' },
  { name: 'Map', icon: MapIcon, category: 'Navigation' },
  { name: 'Menu', icon: Menu, category: 'Interface' },
  { name: 'Message', icon: Message, category: 'Communication' },
  { name: 'MessageText', icon: MessageText, category: 'Communication' },
  { name: 'Minus', icon: Minus, category: 'Actions' },
  { name: 'MoreVert', icon: MoreVert, category: 'Interface' },
  { name: 'NavArrowDown', icon: NavArrowDown, category: 'Arrows' },
  { name: 'NavArrowLeft', icon: NavArrowLeft, category: 'Arrows' },
  { name: 'NavArrowRight', icon: NavArrowRight, category: 'Arrows' },
  { name: 'NavArrowUp', icon: NavArrowUp, category: 'Arrows' },
  { name: 'Network', icon: Network, category: 'Technology' },
  { name: 'Package', icon: Package, category: 'Objects' },
  { name: 'Page', icon: Page, category: 'Files' },
  { name: 'PageEdit', icon: PageEdit, category: 'Files' },
  { name: 'Palette', icon: Palette, category: 'Design' },
  { name: 'Plus', icon: Plus, category: 'Actions' },
  { name: 'PlusCircle', icon: PlusCircle, category: 'Actions' },
  { name: 'Position', icon: Position, category: 'Interface' },
  { name: 'Refresh', icon: Refresh, category: 'Actions' },
  { name: 'RefreshDouble', icon: RefreshDouble, category: 'Actions' },
  { name: 'Rocket', icon: Rocket, category: 'Objects' },
  { name: 'Search', icon: Search, category: 'Interface' },
  { name: 'SelectPoint3d', icon: SelectPoint3d, category: 'Interface' },
  { name: 'Send', icon: Send, category: 'Communication' },
  { name: 'Server', icon: Server, category: 'Technology' },
  { name: 'Settings', icon: Settings, category: 'Interface' },
  { name: 'ShareIos', icon: ShareIos, category: 'Social' },
  { name: 'Shield', icon: Shield, category: 'Security' },
  { name: 'Sparks', icon: Sparks, category: 'Interface' },
  { name: 'SquareDashed', icon: SquareDashed, category: 'Shapes' },
  { name: 'Star', icon: Star, category: 'Social' },
  { name: 'StatsUpSquare', icon: StatsUpSquare, category: 'Data' },
  { name: 'Terminal', icon: Terminal, category: 'Development' },
  { name: 'TestTube', icon: TestTube, category: 'Science' },
  { name: 'Trash', icon: Trash, category: 'Actions' },
  { name: 'Undo', icon: Undo, category: 'Actions' },
  { name: 'Upload', icon: Upload, category: 'Actions' },
  { name: 'User', icon: User, category: 'Users' },
  { name: 'ViewGrid', icon: ViewGrid, category: 'Interface' },
  { name: 'WarningCircle', icon: WarningCircle, category: 'Alerts' },
  { name: 'WarningSquare', icon: WarningSquare, category: 'Alerts' },
  { name: 'WarningTriangle', icon: WarningTriangle, category: 'Alerts' },
  { name: 'Xmark', icon: Xmark, category: 'Actions' }
];

const iconsByExactName = Object.fromEntries(
  ICONOIR_ICONS.map(icon => [icon.name, icon.icon])
) as Record<string, IconoirIcon>;

const iconNameByNormalized = Object.fromEntries(
  ICONOIR_ICONS.map(icon => [normalizeIconName(icon.name), icon.name])
) as Record<string, string>;

export const resolveIconName = (name: string): string | undefined => {
  if (!name) {
    return undefined;
  }

  if (iconsByExactName[name]) {
    return name;
  }

  const normalized = normalizeIconName(name);
  const iconoirName = iconNameByNormalized[normalized];
  if (iconoirName) {
    return iconoirName;
  }

  return FONT_AWESOME_TO_ICONOIR[normalized];
};

export const getIconByName = (name: string): IconoirIcon | undefined => {
  const resolvedName = resolveIconName(name);
  return resolvedName ? iconsByExactName[resolvedName] : undefined;
};

export const getIconsByCategory = (category: string): IconOption[] =>
  ICONOIR_ICONS.filter(icon => icon.category === category);
